<template>
  <div class="orderInfo">
    <el-tabs type="border-card" class="mt-10">
      <el-tab-pane label="反馈记录">
        <el-row>
          <el-timeline>
            <el-timeline-item v-for="reflect in reflects" :key="reflect.id"
              :timestamp="reflect.created_at" placement="top">
              <el-card>
                <h5>{{ reflect.executor }} 通过 {{ reflect.contact_type }} 进行联系 <span
                    v-if="reflect.contact_duration"> 沟通了
                    {{ reflect.contact_duration }} 秒</span>
                  客户意向
                  <span v-if="reflect.satisfy === 1">A</span>
                  <span v-else-if="reflect.satisfy === 2">B</span>
                  <span v-else-if="reflect.satisfy === 3">C</span>
                  <span v-else-if="reflect.satisfy === 4">D</span>
                </h5>
                <p>{{ reflect.reflect_content }}</p>
                <ul class="el-upload-list el-upload-list--picture">
                  <li class="el-upload-list__item is-success" v-for="image in reflect.images"
                    :key="image.id">
                    <img class="el-upload-list__item-thumbnail" :src="image.url">
                    <a class="el-upload-list__item-name"
                      @click="handleReflectPreview(image)">{{ image.name }}</a>
                  </li>
                </ul>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-row>
      </el-tab-pane>
      <el-tab-pane label="操作记录">
        <el-row>
          <el-timeline>
            <el-timeline-item v-for="log in logs" :key="log.id" :timestamp="log.created_at"
              placement="top">
              <el-card>
                <p>{{ log.log_content }}</p>
              </el-card>
            </el-timeline-item>
          </el-timeline>
        </el-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import Timeline from 'wavesurfer.js/dist/plugin/wavesurfer.timeline.js'
export default {
  name: 'OrderHandleInfo',
  props: {
    orderId: Number,
  },
  data() {
    return {
      id: null,
      reflects: [],
      logs: []
    }
  },
  watch: {
    orderId: function (val) {
      this.reflects = []
      this.logs = []
      this.id = val || null
      if (val) {
        this.getOrderInfo()
      }
    }
  },
  computed: {
    actionHost: {
      get: function () {
        return process.env.NODE_ENV === 'development'
          ? ''
          : 'https://weixin.qiyehuo.com'
      },
    }
  },
  methods: {
    getOrderInfo() {
      this.$axios.get('/api/admin/tycOrders/info/' + this.id).then((res) => {
        let { data } = res
        if (data.code === 0) {
          this.reflects = data.data.reflects
          this.logs = data.data.logs
        }
      })
    },
    handleReflectPreview(file) {
      let tempwindow = window.open('_blank')
      tempwindow.location = file.url
    }
  },
}
</script>

<style lang="stylus" scoped>
.orderInfo {
  .count-style {
    display: inherit;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mt-10 {
    margin-top: 0.2rem;
  }

  .el-card__body p {
    margin-top: 0.4rem;
  }

  .el-dialog .el-select {
    width: 100%;

    .el-tag + .el-tag {
      margin-left: 10px;
    }

    .button-new-tag {
      margin-left: 10px;
      height: 32px;
      line-height: 30px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .input-new-tag {
      width: 90px;
      margin-left: 10px;
      vertical-align: bottom;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/common/OrderHandleInfo.vue